export const getters = {
  selectedVariantString(state) {
    const { selectedVariant } = state;
    const variantString = [];
    Object.values(selectedVariant).forEach((value) => {
      variantString.push(value);
    });
    return variantString.join("|");
  },
};
